$(document).ready(function () {
    document.onreadystatechange = function () {
        if (document.readyState === "complete") {
            $('img:not([alt])').attr('alt', '');
        } else {
            window.onload = function () {
                $('img:not([alt])').attr('alt', '');
            };
        };
    }

    jQuery('img[src*="https://cdn.shopify.com/s/files/1/2455/6161/files/product_info_bundler_600x600_6_480x480.jpg?v=1611606624"]').attr('alt', 'Bundle up and save $20. Build your kit.');
    jQuery('img[src*="https://cdn.shopify.com/s/files/1/2455/6161/files/vessel_icons_7591fb56-8ec1-4ed8-9fdf-f372f92adbfa_large.png?v=155926545"]').attr('alt', '5V charger only. Warning - Not waterproof.');
  	jQuery('img[data-src*="//cdn.shopify.com/s/files/1/2455/6161/files/Screen_Shot_2021-06-01_at_6.12.29_PM_1600x.png?v=1622596441"]').attr('alt','Summer sale begins now. Up to $25 off.');
  	
    jQuery('a.banner--full-link').each(function(i){
		// parse url for label
    var url = this.href.substring(this.href.lastIndexOf('/') + 1);
    var label = url.replace(/-/g,' ');
    jQuery(this).attr("aria-label", "Go to " + label + " page.");
  });
  
    jQuery('button.button.ajax-submit.action_button.button--add-to-cart').keydown(function (event) {
        event.preventDefault();
        var keycode = (event.keyCode ? event.keyCode : event.which);
        if (keycode == '13' || keycode == '32') {
          this.click();
          jQuery('#theme-ajax-cart:not(.jsAjaxCart)').addClass('is-visible');
          jQuery('.ajax-cart__overlay:not(.jsAjaxCart)').addClass('is-visible');
          setTimeout(function () {
            jQuery('#theme-ajax-cart:not(.jsAjaxCart)').focus();
          }, 1000);
        }
      return false;
    });


    jQuery('button.button.ajax-submit.action_button.button--add-to-cart').click(function (event) {
        setTimeout(function () {
            jQuery('#theme-ajax-cart:not(.jsAjaxCart)').focus();
        }, 1000);
    });

});

// add all the elements inside modal which you want to make focusable
const  focusableElements =
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
const modal = document.querySelector('#ageModal'); // select the modal by it's id

const firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
const focusableContent = modal.querySelectorAll(focusableElements);
const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal


document.addEventListener('keydown', function(e) {
  let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

  if (!isTabPressed) {
    return;
  }

  if (e.shiftKey) { // if shift key pressed for shift + tab combination
    if (document.activeElement === firstFocusableElement) {
      lastFocusableElement.focus(); // add focus for the last focusable element
      e.preventDefault();
    }
  } else { // if tab key is pressed
    if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
      firstFocusableElement.focus(); // add focus for the first focusable element
      e.preventDefault();
    }
  }
});

firstFocusableElement.focus();
